import { Component } from '../core/smpl-components.js'
import { LogoBounce } from '../modules/logo-bounce.js'

// -----------------------------------------------------------------------------
// Logo — a wordmark link whose "berg" half bounces up on hover, like the one in
// the nav overlay. All the behaviour lives in modules/logo-bounce.js.
// Selector: `.js-logo`, a link wrapping the inline logo.svg.
// -----------------------------------------------------------------------------
export default class extends Component {
	mount() {
		this.logo = new LogoBounce(this.element)
	}

	unmount() {
		this.logo.destroy()
		this.logo = null
	}
}
